import type React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { Link as RouterLink } from 'react-router-dom'

const NotFoundV2: React.FC = () => (
  <Box sx={{ textAlign: 'center', py: 8 }}>
    <Typography variant="h5" gutterBottom>
      Page not found
    </Typography>
    <Typography color="text.secondary" sx={{ mb: 3 }}>
      That page doesn&apos;t exist in the new experience yet.
    </Typography>
    <Button component={RouterLink} to="/v2" variant="contained">
      Back to Home
    </Button>
  </Box>
)

export default NotFoundV2
